<div
  [ngStyle]="{ 'background-color': getBackgroundColor() }"
  class="py-1 pl-3 rounded-lg flex items-center w-fit"
>
  <mat-icon
    [svgIcon]="getIcon()"
    [ngStyle]="{ color: getIconColor() }"
    class="text-[24px] shrink-0"
  >
  </mat-icon>
  <p [ngStyle]="{ color: getTextColor() }" class="text-[16px] font-semibold px-3">
    {{ config().message }}
  </p>
</div>
